import React from "react";
import { motion } from "framer-motion";
import SculptureScene from "../components/SculptureScene";

const pageTransition = {
  initial: { opacity: 0, scale: 0.98, filter: "blur(8px)" },
  animate: { 
    opacity: 1, 
    scale: 1, 
    filter: "blur(0px)",
    transition: { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }
  },
  exit: { 
    opacity: 0, 
    scale: 1.02, 
    filter: "blur(8px)",
    transition: { duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }
  },
};

export default function Home() {
  return (
    <motion.div
      data-testid="home-page"
      variants={pageTransition}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
        background: "#FFFFFF",
      }}
    >
      {/* 3D Canvas - full background */}
      <div
        data-testid="sculpture-canvas"
        style={{ position: "absolute", inset: 0, zIndex: 0 }}
      >
        <SculptureScene />
      </div>

      {/* Soft radial vignette */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          background:
            "radial-gradient(ellipse at center, transparent 50%, rgba(248,246,243,0.15) 100%)",
          pointerEvents: "none",
        }}
      />

      {/* Top intro text in green box */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        style={{
          position: "absolute",
          top: "24px",
          left: 0,
          right: 0,
          zIndex: 10,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            background: "#BFFF00",
            borderRadius: "4px",
            padding: "8px 16px",
          }}
        >
          <span
            style={{
              fontFamily: "'Garet', sans-serif",
              fontWeight: 700,
              fontSize: "0.85rem",
              letterSpacing: "0.02em",
              color: "#1a1a1a",
            }}
          >
            HELLO, I'M SHIRA AND
          </span>
        </div>
      </motion.div>

      {/* Editorial quote - absolute center via flexbox (no transform conflict) */}
      <motion.div
        data-testid="editorial-quote"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 1.1, ease: "easeOut" }}
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 10,
          pointerEvents: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <motion.div
          initial={{ y: 20 }}
          animate={{ y: 0 }}
          transition={{ delay: 0.4, duration: 1.1, ease: "easeOut" }}
          style={{ textAlign: "center", width: "90%", maxWidth: "900px" }}
        >
          <h1
            style={{
              fontFamily: "'Garet', sans-serif",
              fontSize: "clamp(1.4rem, 4.5vw, 4.5rem)",
              lineHeight: 1.1,
              letterSpacing: "-0.01em",
              textTransform: "uppercase",
              color: "#0A0A0A",
              margin: 0,
              textShadow:
                "0 0 40px rgba(255,255,255,0.98), 0 0 80px rgba(255,255,255,0.8)",
              whiteSpace: "nowrap",
            }}
          >
            <span style={{ fontWeight: 700, display: "block", whiteSpace: "nowrap" }}>Sometimes instead of</span>
            <span style={{ fontWeight: 700, display: "block", whiteSpace: "nowrap" }}>facing my problems</span>
            <span style={{ 
              fontWeight: 400,
              color: "#8B8BF5",
              display: "block",
              whiteSpace: "nowrap",
            }}>
              I design them away
            </span>
          </h1>
        </motion.div>
      </motion.div>

      {/* Sticky navigation at bottom */}
    </motion.div>
  );
}
